import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import UnopDropdown from "unop-react-dropdown";
import CatPageHook from "../../hook/category/CatPageHook";
import HomeBrandHook from "../../hook/brand/HomeBrandHook";

import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";

const CategoryHeader = () => {
  const [category, loading, pageCount, getPage] = CatPageHook();
  const [brand, brandLoading] = HomeBrandHook();
  const settingsRes = useSelector((state) => state.settingsReducers.settings);

  const { t } = useTranslation();
  return (
    <div className="noon-cat-header d-none d-md-block">
      <Container>
        <div className="noon-cat-header-inner position-relative overflow-visible">
          <Link to={`/allcategory`} style={{ textDecoration: "none" }}>
            <div className="noon-cat-item">
              <strong>{t("All Categories")}</strong>
            </div>
          </Link>

          {category
            ? category.slice(0, 8).map((el) => {
                return (
                  <div key={el._id} className="noon-cat-item mega-menu-trigger">
                    <Link
                      to={`/category/subCategory/${el._id}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {Cookies.get("i18next") === "ar" ? el.nameAr : el.nameEn}
                    </Link>

                    {el.subCategory && el.subCategory.length > 0 && (
                      <div className="mega-menu-dropdown" style={{ flexDirection: 'column' }}>
                        {/* Top row: Subcategories + Category Image */}
                        <div style={{ display: 'flex', flex: 1 }}>
                          <div className="mega-menu-column">
                            <div className="mega-menu-title">
                              {t("Subcategories")}
                            </div>
                            {el.subCategory.map((item) => (
                              <Link
                                key={item._id}
                                to={`/products/subcategory/${item._id}`}
                                className="mega-menu-link"
                              >
                                {Cookies.get("i18next") === "ar"
                                  ? item.nameAr
                                  : item.nameEn}
                              </Link>
                            ))}
                          </div>
                          <div className="mega-menu-column" style={{ borderLeft: Cookies.get("i18next") !== "ar" ? "1px solid rgba(0,0,0,0.08)" : "none", borderRight: Cookies.get("i18next") === "ar" ? "1px solid rgba(0,0,0,0.08)" : "none", paddingLeft: Cookies.get("i18next") !== "ar" ? "24px" : "0", paddingRight: Cookies.get("i18next") === "ar" ? "24px" : "0", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                           {el.image && (
                             <img src={el.image} alt={Cookies.get("i18next") === "ar" ? el.nameAr : el.nameEn} style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain', borderRadius: '8px' }} />
                           )}
                          </div>
                        </div>

                        {/* Bottom row: Brands */}
                        {brand && brand.data && brand.data.length > 0 && (
                          <div style={{ borderTop: '1px solid rgba(0,0,0,0.06)', paddingTop: '16px', marginTop: '16px' }}>
                            <div className="mega-menu-title" style={{ marginBottom: '10px' }}>{t("Brands")}</div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
                              {brand.data.filter(b => b.status === true).slice(0, 8).map((b) => (
                                <Link key={b._id} to={`/products/brand/${b._id}?page=1`} style={{ textDecoration: 'none' }}>
                                  <div className="mega-brand-item">
                                    <img src={b.logo} alt={b.nameAr} className="mega-brand-logo" />
                                    <span className="mega-brand-name">
                                      {Cookies.get("i18next") === "ar" ? b.nameAr : b.nameEn}
                                    </span>
                                  </div>
                                </Link>
                              ))}
                              <Link to="/allbrand" style={{ textDecoration: 'none', fontWeight: 700, color: 'var(--primary-color)', fontSize: '13px', fontFamily: 'Tajawal', marginInlineStart: '8px' }}>
                                {t("View all brands")} →
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
            : null}
        </div>
      </Container>
    </div>
  );
};

export default CategoryHeader;
